import axiosInstance from '../../../config/axiosInstance';
const ReportService = {
    async GetAllReports(ModuleID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/GetAllReports?ClientID=${ClientID}&ModuleID=${ModuleID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async getReportDetail(ReportID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Dashboard/ReportDetail?ReportID=${ReportID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching report details:', error);
            throw error;
        }
    },

    async executeReport(ReportID, inputValues) {
        try {
            const response = await axiosInstance.post(
                `/Dashboard/ReportExecution?ReportID=${ReportID}`,
                inputValues, // <-- make sure this is an object
                { headers: { 'Content-Type': 'application/json' } } // important
            );
            return response.data;
        } catch (error) {
            console.error('Error executing report:', error);
            throw error;
        }
    }

};

export default ReportService;